// api.js
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://unflagged-ayden-unannoyed.ngrok-free.dev/api',
  headers: {
    'ngrok-skip-browser-warning': 'true',
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Toujours ajouter le header ngrok
    config.headers['ngrok-skip-browser-warning'] = 'true';
    // Identifiant d'appareil stable (liage de session anti-vol de jeton)
    let did = localStorage.getItem('device_id');
    if (!did) {
      did = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : String(Date.now()) + Math.random().toString(36).slice(2);
      localStorage.setItem('device_id', did);
    }
    config.headers['X-Device-Id'] = did;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle auth errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;